import MarketAnalysisProduct from '@/modules/neodash/pages/marketAnalysisByProduct/market-analysis-product.page.vue';
import MarketAnalysisLocale from '@/modules/neodash/pages/marketAnalysisLocale/market-analysis-locale.page.vue';

import ToyotaGoalVsRegistrationReport from '@/modules/business-plan/modules/report/toyota-goal-vs-registration-report.page.vue';
import PbiAfterSalesPage from '@/modules/neodash/containers/powerbi/pbi-after-sales.page.vue';
import PbiDashboardSalesReportPage from '@/modules/neodash/containers/powerbi/pbi-dashboard-sales-report.page.vue';
import PbiDealerProfilePage from '@/modules/neodash/containers/powerbi/pbi-dealer-profile.page.vue';
import PbiGreenfieldPage from '@/modules/neodash/containers/powerbi/pbi-greenfield.page.vue';
import PbiMarketDiagnosisFiatDealerGroupPage from '@/modules/neodash/containers/powerbi/pbi-market-diagnosis-fiat-dealer-group.page.vue';
import PbiMarketDiagnosisFordDealerGroupPage from '@/modules/neodash/containers/powerbi/pbi-market-diagnosis-ford-dealer-group.page.vue';
import PbiMarketDiagnosisStellantisPage from '@/modules/neodash/containers/powerbi/pbi-market-diagnosis-stellantis.page.vue';
import PbiMarketDiagnosisNewPage from '@/modules/neodash/containers/powerbi/pbi-market-diagnosis-new.page.vue';
import PbiParticipationTrainingPage from '@/modules/neodash/containers/powerbi/pbi-participation-training.page.vue';
import PbiConversionReportPage from '@/modules/neodash/containers/powerbi/pbi-conversion-report.page.vue';
import { ReportEnum } from '@/modules/neodash/model/types/enums/reportEnum';
import AnnualSalesPerformance from '@/modules/neodash/pages/annualSalePerformance/annual-sales-performance.page.vue';
import FordMarketShareBrand from '@/modules/neodash/pages/fordMarketShareBrand/ford-market-share-brand.page.vue';
import FordThroughput from '@/modules/neodash/pages/fordThroughput/ford-throughput.page.vue';
import MarketBreakdown from '@/modules/neodash/pages/marketBreakDown/market-break-down.page.vue';
import MarketEvolution from '@/modules/neodash/pages/marketEvolution/market-evolution.page.vue';
import MarketSummary from '@/modules/neodash/pages/marketSummary/market-summary.page.vue';
import NearestReports from '@/modules/neodash/pages/nearestReports/nearest-reports.page.vue';
import RegistrationSegmentRegion from '@/modules/neodash/pages/registration-segment-region/registration-segment-region.page.vue';
import RegistrationByBrandAndSegment from '@/modules/neodash/pages/registrationByBrandAndSegment/registration-brand-segment.page.vue';
import SegmentPerformance from '@/modules/neodash/pages/segmentPerformance/segment-performance.page.vue';
import PbiDealerEvaluationPage from '@/modules/neodash/containers/powerbi/pbi-dealer-evaluation.page.vue';
import PbiBasketComparisonPage from '@/modules/neodash/containers/powerbi/pbi-basket-comparison.page.vue';
import PbiDealerGroupPage from '@/modules/neodash/containers/powerbi/pbi-dealer-group.page.vue';
import PbiDncUnmetDemandSalesGapLatamPage from '@/modules/neodash/containers/powerbi/pbi-dnc-unmetdemand-sales-gap-latam.page.vue';
import PbiRecallMonitorPage from '@/modules/neodash/containers/powerbi/pbi-recall-monitor.page.vue';
import PbiDashboardDrdProjection from '@/modules/neodash/containers/powerbi/pbi-dashboard-drd-projection.page.vue';
import PbiGmDncS10Study from '@/modules/neodash/containers/powerbi/pbi-gm-dnc-s10-study.page.vue';
import PbiDealerNetworkingBalancePage from '@/modules/neodash/containers/powerbi/pbi-dealer-networking-balance.page.vue';
import PbiDncBacktestAnalysisPage from '@/modules/neodash/containers/powerbi/pbi-dnc-backtest-analysis.page.vue';
import PbiEvTechReportPage from '@/modules/neodash/containers/powerbi/pbi-ev-tech-report.page.vue';
import PbiVehicleFleetCirculationPage from '@/modules/neodash/containers/powerbi/pbi-vehicle-fleet-circulation.page.vue';
import PbiWtlAfterSalesPage from '@/modules/neodash/containers/powerbi/pbi-wtl-after-sales.page.vue';
import PbiSalesRegistrationEffectivenessPage from '@/modules/neodash/containers/powerbi/pbi-sales-registration-effectiveness.page.vue';
import PbiNetworkSimulatorAutoPage from '../../containers/powerbi/pbi-network-simulator-auto.page.vue';
import PbiPerfomanceTrackingPage from '../../containers/powerbi/pbi-perfomance-tracking.page.vue';
import DncReportPage from '../../containers/export-reports/dnc-report.vue';
import PbiAreaSegmentationAnalysisPage from '../../containers/powerbi/pbi-area-segmentation-analysis.page.vue';
import PbiAnnualSalesPerformancePage from '../../containers/powerbi/pbi-annual-sales-performance.page.vue';
import PbiSouthAmericaPage from '../../containers/powerbi/pbi-south-america.page.vue';
import PbiMulticriteriaAnalysis from '../../containers/powerbi/pbi-multicriteria-analysis.page.vue';
import PbiNewDncBacktestAnalysis from '../../containers/powerbi/pbi-new-dnc-backtest-analysis.page.vue';
import PbiMarketPotentialPage from '../../containers/powerbi/pbi-market-potential.page.vue';
import Pbi2wPartsIntelligencePage from '../../containers/powerbi/pbi-2w-parts-intelligence.page.vue';
import PbiAnnualSalesPerformanceExportPage from '../../containers/powerbi/pbi-annual-sales-perfomance-export.page.vue';
import PbiGroupMappingPage from '@/modules/neodash/containers/powerbi/pbi-group-mapping.page.vue';

//AfterSales
import PbiNetworkSimulatorAfterSalesPage from '../../containers/powerbi/aftersales/pbi-network-simulator-aftersales.page.vue';

import Vue, { AsyncComponent, ComponentOptions } from 'vue';

interface cardBasicInfo {
  reportId: ReportEnum;
  reportType: reportTypeEnum;
  reportName: string;
  reportContext: reportContextEnum;
  new: boolean;
}

export interface basicCardReport extends cardBasicInfo {
  reportKey: string;
}

export interface cardReportWithSubKey extends basicCardReport {
  reportSubKey: string;
}

export interface refactoredCardInfo extends basicCardReport {
  reportType: reportTypeEnum.refactoredCard;
  component: ComponentOptions<Vue> | typeof Vue | AsyncComponent;
}

export type cardReport = basicCardReport | cardReportWithSubKey;
type cardApp = cardBasicInfo;
export type cardInfo = cardReport | cardApp | refactoredCardInfo;

export enum reportTypeEnum {
  reportViewer,
  reportPage,
  dapEmptyProject,
  dapSubmittedProjects,
  dapSubmittedProjectsRetail,
  unmetDemand,
  refactoredCard,
  businessPlanApproval
}

export enum reportContextEnum {
  drd,
  distribution,
  directSale,
  afterSales
}

export const lstCards: cardInfo[] = [
  {
    reportId: ReportEnum.PbiMarketDiagnosisStellantis,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Diagnosis - Stellantis',
    reportKey: 'report-pbi-market-diagnosis-stellantis-access',
    reportContext: reportContextEnum.drd,
    component: PbiMarketDiagnosisStellantisPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiParticipationTrainingGM,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Uso do GIG e Participação em Treinamentos',
    reportKey: 'report-pbi-participation-training-access',
    reportContext: reportContextEnum.drd,
    component: PbiParticipationTrainingPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiMarketDiagnosisFiatDealerGroup,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Diagnosis - Fiat Dealer Group',
    reportKey: 'report-pbi-market-diagnosis-fiatdealer-access',
    reportContext: reportContextEnum.directSale,
    component: PbiMarketDiagnosisFiatDealerGroupPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiMarketDiagnosisFordDealerGroup,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Diagnosis - Ford Dealer Group',
    reportKey: 'report-pbi-market-diagnosis-forddealer-access',
    reportContext: reportContextEnum.directSale,
    component: PbiMarketDiagnosisFordDealerGroupPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiMarketDiagnosisNew,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Diagnosis',
    reportKey: 'report-pbi-market-diagnosis-new-access',
    reportContext: reportContextEnum.drd,
    component: PbiMarketDiagnosisNewPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiGreenfield,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Greenfield Solution',
    reportKey: 'report-pbi-greenfield-solution-access',
    reportContext: reportContextEnum.drd,
    component: PbiGreenfieldPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDashboardSalesReport,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dashboard Sales Report',
    reportKey: 'report-pbi-dashboard-sales-access',
    reportContext: reportContextEnum.drd,
    component: PbiDashboardSalesReportPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDealerProfile,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dealer Profile',
    reportKey: 'report-pbi-dealer-profile',
    reportContext: reportContextEnum.drd,
    component: PbiDealerProfilePage
  } as cardInfo,
  {
    reportId: ReportEnum.MarketSummary,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Summary',
    reportKey: 'market-summary',
    reportContext: reportContextEnum.drd,
    component: MarketSummary
  } as cardInfo,
  {
    reportId: ReportEnum.MarketBreakDown,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Market Break Down',
    reportKey: 'market-break-down',
    reportContext: reportContextEnum.drd,
    component: MarketBreakdown
  } as cardInfo,
  {
    reportId: ReportEnum.DNCParameters,
    reportType: reportTypeEnum.unmetDemand,
    reportName: 'Report.DNCParameterization',
    reportContext: reportContextEnum.drd
  } as cardInfo,
  {
    reportId: ReportEnum.MarketAnalysisLocale,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Análise de mercado',
    reportContext: reportContextEnum.drd,
    component: MarketAnalysisLocale,
    reportKey: 'market-analysis-locale'
  } as cardInfo,
  {
    reportId: ReportEnum.MarketAnalysisByProduct,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Análise de Mercado por Produto',
    reportContext: reportContextEnum.drd,
    component: MarketAnalysisProduct,
    reportKey: 'market-analysis-product'
  } as cardInfo,
  {
    reportId: ReportEnum.MarketEvolution,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Evolução do Mercado',
    reportKey: 'market-evolution',
    reportContext: reportContextEnum.drd,
    component: MarketEvolution
  } as cardInfo,
  {
    reportId: ReportEnum.AnnualSalesPerformance,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Performance de Vendas Anual',
    reportKey: 'annual-sale-performance',
    reportContext: reportContextEnum.drd,
    component: AnnualSalesPerformance
  } as cardInfo,
  {
    reportId: ReportEnum.SegmentPerformanceDetailed,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Análise da Área e Segmentação',
    reportKey: 'performance-segment-detailed',
    reportContext: reportContextEnum.drd,
    component: SegmentPerformance
  } as cardInfo,
  {
    reportId: ReportEnum.RegistrationSegmentRegion,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Report.RegistrationSegmentRegion',
    reportKey: 'registration-segment-version',
    reportContext: reportContextEnum.drd,
    component: RegistrationSegmentRegion
  } as cardInfo,
  {
    reportId: ReportEnum.RegistrationByBrandAndSegment,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Report.RegistrationByBrandAndSegment',
    reportKey: 'registration-brand-segment',
    reportContext: reportContextEnum.drd,
    component: RegistrationByBrandAndSegment
  } as cardInfo,
  {
    reportId: ReportEnum.NearestReports,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Report.RoutesGenerated',
    reportKey: 'nearest-distances-card',
    reportContext: reportContextEnum.drd,
    component: NearestReports
  } as cardInfo,
  {
    reportId: ReportEnum.BusinessPlanApproval,
    reportType: reportTypeEnum.businessPlanApproval,
    reportName: 'Business Plan Approval',
    reportContext: reportContextEnum.drd
  } as cardInfo,
  {
    reportId: ReportEnum.DirectSalesGoalAndRegistration,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Meta de Venda Direta',
    reportKey: 'direct-sales-goals',
    reportContext: reportContextEnum.directSale,
    component: ToyotaGoalVsRegistrationReport
  } as cardInfo,
  {
    reportId: ReportEnum.FordMarketShareBrand,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Share por Cidade',
    reportKey: 'ford-market-share-brand',
    reportContext: reportContextEnum.drd,
    component: FordMarketShareBrand
  } as cardInfo,
  {
    reportId: ReportEnum.FordThroughput,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Throughput',
    reportContext: reportContextEnum.drd,
    reportKey: 'ford-throughput',
    component: FordThroughput
  } as cardInfo,
  {
    reportId: ReportEnum.PbiConversionReport,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Conversion Report',
    reportKey: 'report-pbi-conversion-report-access',
    reportContext: reportContextEnum.drd,
    component: PbiConversionReportPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDealerEvaluation,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dealer Evaluation',
    reportKey: 'report-pbi-dealer-evaluation-access',
    reportContext: reportContextEnum.drd,
    component: PbiDealerEvaluationPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiBasketComparison,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Cesta de Comparação por Placa',
    reportKey: 'report-pbi-basket-comparison',
    reportContext: reportContextEnum.drd,
    component: PbiBasketComparisonPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDealerGroup,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dealer Groups',
    reportKey: 'report-pbi-dealer-group',
    reportContext: reportContextEnum.drd,
    component: PbiDealerGroupPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDncUnmetDemandSalesGapLatam,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Unmet Demand & Sales Gap',
    reportKey: 'report-pbi-dnc-unmet-demand-sales-gap-latam',
    reportContext: reportContextEnum.drd,
    component: PbiDncUnmetDemandSalesGapLatamPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDashboardDrdProjection,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'DRD Projeção',
    reportKey: 'report-pbi-dashboard-drd-projection',
    reportContext: reportContextEnum.drd,
    component: PbiDashboardDrdProjection
  } as cardInfo,
  {
    reportId: ReportEnum.PbiGmDncS10Study,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'GM - DNC S10 Study',
    reportKey: 'report-pbi-gm-dnc-s10-study',
    reportContext: reportContextEnum.drd,
    component: PbiGmDncS10Study
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDealerNetworkingBalance,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dealer Network Balance',
    reportKey: 'report-pbi-dealer-networking-balance',
    reportContext: reportContextEnum.drd,
    component: PbiDealerNetworkingBalancePage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiDncBacktestAnalysis,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'DNC - Backtest Analysis',
    reportKey: 'report-pbi-dnc-backtest-analysis',
    reportContext: reportContextEnum.drd,
    component: PbiDncBacktestAnalysisPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiEvTechReport,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'EV Tech Report',
    reportKey: 'report-pbi-ev-tech-report',
    reportContext: reportContextEnum.drd,
    component: PbiEvTechReportPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiVehicleFleetCirculation,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Parque Circulante',
    reportKey: 'report-pbi-vehicle-fleet-circulation',
    reportContext: reportContextEnum.drd,
    component: PbiVehicleFleetCirculationPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiRecallMonitor,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Recall Monitor',
    reportKey: 'report-pbi-recall-monitor',
    reportContext: reportContextEnum.drd,
    component: PbiRecallMonitorPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiAfterSales,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Greenfield Solution - After Sales',
    reportKey: 'report-pbi-after-sales-access',
    reportContext: reportContextEnum.drd,
    component: PbiAfterSalesPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiNetworkSimulatorAfterSales,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Network Simulator',
    reportKey: 'report-pbi-after-sales-network-simulator',
    reportContext: reportContextEnum.drd,
    component: PbiNetworkSimulatorAfterSalesPage
  } as cardInfo,
  {
    reportId: ReportEnum.DncReportPage,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'DNC — Relatório de Exportação',
    reportKey: 'report-dnc-export',
    reportContext: reportContextEnum.drd,
    component: DncReportPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiWtlAfterSales,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'WTL After Sales',
    reportKey: 'report-pbi-wtl-after-sales',
    reportContext: reportContextEnum.drd,
    component: PbiWtlAfterSalesPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiSalesRegistrationEffectiveness,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Sales x Registration Effectiveness',
    reportKey: 'report-pbi-sales-registration-effectiveness',
    reportContext: reportContextEnum.drd,
    component: PbiSalesRegistrationEffectivenessPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiNetworkSimulatorAutoPage,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Network Simulator Auto',
    reportKey: 'report-pbi-network-simulator-auto',
    reportContext: reportContextEnum.drd,
    component: PbiNetworkSimulatorAutoPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiPerfomanceTrackingPage,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Performance Tracking',
    reportKey: 'report-pbi-perfomance-tracking',
    reportContext: reportContextEnum.drd,
    component: PbiPerfomanceTrackingPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiAreaSegmentationAnalysis,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Análise de Área e Segmentação 2.0',
    reportKey: 'report-pbi-area-segmentation-analysis',
    reportContext: reportContextEnum.drd,
    component: PbiAreaSegmentationAnalysisPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiAnnualSalesPerformance,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Performance de Venda Anual 2.0',
    reportKey: 'report-pbi-annual-sales-performance',
    reportContext: reportContextEnum.drd,
    component: PbiAnnualSalesPerformancePage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiSouthAmerica,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'South America Report',
    new: false,
    reportKey: 'report-pbi-south-america',
    reportContext: reportContextEnum.drd,
    component: PbiSouthAmericaPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiMulticriteriaAnalysis,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Dream - Multicriteria Analysis',
    new: false,
    reportKey: 'report-pbi-multicriteria-analysis',
    reportContext: reportContextEnum.drd,
    component: PbiMulticriteriaAnalysis
  } as cardInfo,
  {
    reportId: ReportEnum.PbiNewDncBacktestAnalysis,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'DNC - Backtest Analysis (2026)',
    new: false,
    reportKey: 'report-pbi-new-dnc-backtest-analysis',
    reportContext: reportContextEnum.drd,
    component: PbiNewDncBacktestAnalysis
  } as cardInfo,
  {
    reportId: ReportEnum.PbiMarketPotential,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Potencial de Mercado',
    new: false,
    reportKey: 'report-pbi-market-potential',
    reportContext: reportContextEnum.drd,
    component: PbiMarketPotentialPage
  } as cardInfo,
  {
    reportId: ReportEnum.Pbi2wPartsIntelligence,
    reportType: reportTypeEnum.refactoredCard,
    reportName: '2W Parts Intelligence',
    new: false,
    reportKey: 'report-pbi-2w-parts-intelligence',
    reportContext: reportContextEnum.drd,
    component: Pbi2wPartsIntelligencePage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiAnnualSalesPerformanceExport,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Performance de Vendas Anual - Exportação',
    new: true,
    reportKey: 'report-pbi-annual-sales-performance-export',
    reportContext: reportContextEnum.drd,
    component: PbiAnnualSalesPerformanceExportPage
  } as cardInfo,
  {
    reportId: ReportEnum.PbiGroupMapping,
    reportType: reportTypeEnum.refactoredCard,
    reportName: 'Mapeamento de Grupos',
    reportKey: 'report-pbi-group-mapping-access',
    reportContext: reportContextEnum.drd,
    component: PbiGroupMappingPage
  } as cardInfo,
];
